import Icon from "@ant-design/icons";

// Simple folder icon for categories
const FolderIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 5.83333C2.5 4.91286 3.24619 4.16667 4.16667 4.16667H8.33333L10 6.66667H15.8333C16.7538 6.66667 17.5 7.41286 17.5 8.33333V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V5.83333Z"
      stroke="#A4A7AE"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CategoryIcon = () => <Icon component={FolderIcon} />;

// Promo codes icon
export const PromocodeIcon = () => (
  <img src="/promocode.svg" alt="Promo codes" width={20} height={20} />
);
